import $ from 'jquery';

const w = window;

w.home24 = w.home24 || {};
w.home24.helpers = w.home24.helpers || {};

w.home24.helpers.doubleclick = (function () {

    'use strict';

    var publicScope = {};
    var privateScope = {};

    privateScope.selectors = {
        iframes: '.iframe-teaser[data-external-url],.iframe[data-external-url]'
    };

    privateScope.convertToIframe = function () {
        var $this = $(this);
        var sUrl = $this.data('externalUrl');
        var iWidth = parseInt($this.data('width'), 10);
        var iHeight = parseInt($this.data('height'), 10);

        if (sUrl && iWidth > 0 && iHeight > 0 && $this.children('iframe').length === 0) {
            $('<iframe></iframe>').attr({
                width: iWidth,
                height: iHeight,
                frameborder: '0',
                scrolling: 'no',
                marginwidth: '0',
                marginheight: '0',
                src: sUrl
            }).appendTo($this);
        }
    };

    publicScope.init = function () {
        $(privateScope.selectors.iframes).each(privateScope.convertToIframe);
    };

    publicScope.init();

    return publicScope;
})();



/** WEBPACK FOOTER **
 ** ./legacy/home24/helpers/doubleclick.js
 **/